import script from "./AddressItem.vue?vue&type=script&setup=true&lang=js"
export * from "./AddressItem.vue?vue&type=script&setup=true&lang=js"

import "./AddressItem.vue?vue&type=style&index=0&id=1ed1ec98&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ed1ec98"]])

export default __exports__